module.exports = __webpack_public_path__ + "4a25a4bb69390869c1267434dfc9e604.MP3";